module.exports = __webpack_public_path__ + "d37248da0b832048254203f4cba48b7a.svg";